module.exports = __webpack_public_path__ + "img/arrow.cf8d6f21.svg";